import React from 'react';
import { Card as MantineCard } from '@mantine/core';

export interface CardProps extends React.ComponentPropsWithoutRef<typeof MantineCard> {
  /** Card content */
  children: React.ReactNode;
  /** Optional CSS class name for custom styling */
  className?: string;
  /** Shadow size (e.g. "sm", "md") */
  shadow?: string;
  /** Border radius (e.g. "sm", "md") */
  radius?: string;
}

/**
 * Generic card component. Wraps Mantine Card for consistent use across the app.
 * Pass className for custom styles (e.g. from CSS modules) or use default Mantine props.
 */
export function Card({ children, className, ...rest }: CardProps) {
  return (
    <MantineCard className={className} {...rest}>
      {children}
    </MantineCard>
  );
}

export default Card;
